<script>
export default {
  name: 'Notification',
  props: {
    type: { type: String, required: true },
    title: { type: String, required: true },
    body: { type: String, required: true },
    show: { type: Boolean, default: false },
  },
};
</script>

<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto
        ring-1 ring-black ring-opacity-5 overflow-hidden">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i class="fas fa-check text-green-400 text-xl" v-if="type === 'success'"></i>
            <i class="fas fa-exclamation-triangle text-red-400 text-xl" v-if="type=='warning'"></i>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900">{{ title }}</p>
            <p class="mt-1 text-sm text-gray-500">{{ body }}</p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button
              @click="$emit('close')"
              class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500">
              <span class="sr-only">Close</span>
              <i class="fas fa-times text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
